import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './agentDealsStatsChart.scss';
import Chart from './chart';
import FixedAxis from './fixedAxis';
const AgentDealsStatsChart = () => _jsxs("div", { className: styles.wrapper, "data-sentry-component": "AgentDealsStatsChart", "data-sentry-source-file": "index.tsx", children: [_jsx(FixedAxis, { "data-sentry-element": "FixedAxis", "data-sentry-source-file": "index.tsx" }), _jsx(Chart, { "data-sentry-element": "Chart", "data-sentry-source-file": "index.tsx" })] });
export default AgentDealsStatsChart;
